// update a tooltip
import { ReinosMaps } from '../../core'

ReinosMaps.prototype.updateTooltip = function (options, feature) {
  this.addTooltip(options, feature)
}
